import React from 'react';

const IncomingRequestActiveIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M18.75 8.18701L14.2506 3.74999C16 3.75 15.5 2.25 14.75 2.25C14 2.25 8.25 2.25 8.25 2.25C7.85218 2.25 7.47064 2.40803 7.18934 2.68934C6.90804 2.97064 6.75 3.35217 6.75 3.75V5.25H5.25C4.85218 5.25 4.47064 5.40803 4.18934 5.68934C3.90804 5.97064 3.75 6.35217 3.75 6.74999V20.25C3.75 20.6478 3.90804 21.0293 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H15.75C16.1478 21.75 16.5294 21.592 16.8107 21.3107C17.092 21.0293 17.25 20.6478 17.25 20.25V18.75H18.75C19.1478 18.75 19.5294 18.592 19.8107 18.3107C20.092 18.0293 20.25 17.6478 20.25 17.25V8.26651C20 7.5 19 7.5 18.75 8.18701ZM12.75 18H8.25C8.05109 18 7.86032 17.921 7.71967 17.7803C7.57902 17.6397 7.5 17.4489 7.5 17.25C7.5 17.0511 7.57902 16.8603 7.71967 16.7197C7.86032 16.579 8.05109 16.5 8.25 16.5H12.75C12.9489 16.5 13.1397 16.579 13.2803 16.7197C13.421 16.8603 13.5 17.0511 13.5 17.25C13.5 17.4489 13.421 17.6397 13.2803 17.7803C13.1397 17.921 12.9489 18 12.75 18ZM12.75 15H8.25C8.05109 15 7.86032 14.921 7.71967 14.7803C7.57902 14.6397 7.5 14.4489 7.5 14.25C7.5 14.0511 7.57902 13.8603 7.71967 13.7197C7.86032 13.579 8.05109 13.5 8.25 13.5H12.75C12.9489 13.5 13.1397 13.579 13.2803 13.7197C13.421 13.8603 13.5 14.0511 13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15ZM18.75 17.25H17.25V9.74999C17.2511 9.55046 17.1737 9.3585 17.0344 9.21562L13.2844 5.46562C13.1415 5.32633 12.9495 5.24887 12.75 5.25H8.25V3.75L14.2506 3.74999L18.75 8.18701V17.25Z'
				fill='#2E2E6B'
			/>
			<path
				d='M20.75 6.25L17 6.25L17 2.5'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M22.25 1L17 6.25'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default IncomingRequestActiveIcon;
